import http from "../../helpers/http";
import * as helpers from "../../helpers/api";
import { toast } from "react-toastify";
import { TOAST_SETTINGS } from "../../utils/siteSettings";
import Text from "../../components/common/Text";

import {
  FETCH_USER_SINGLE_LISTINGS_CONTENT,
  FETCH_USER_SINGLE_LISTINGS_CONTENT_SUCCESS,
  FETCH_USER_SINGLE_LISTINGS_CONTENT_FAILED,
  USER_SINGLE_LISTINGS_DELETE__MESSAGE,
  USER_SINGLE_LISTINGS_DELETE_MESSAGE_SUCCESS,
  USER_SINGLE_LISTINGS_DELETE__MESSAGE_FAILED,
} from "./actionTypes";

export const fetchSingleUserListing = (listing_id) => (dispatch) => {
  dispatch({
    type: FETCH_USER_SINGLE_LISTINGS_CONTENT,
    payload: null,
  });
  http
    .get("single-user-listing/" + listing_id)
    .then(({ data }) => {
      if (data.property === 0) {
        window.location.replace("/listings");
      }
      dispatch({
        type: FETCH_USER_SINGLE_LISTINGS_CONTENT_SUCCESS,
        payload: data,
      });
    })
    .catch((error) => {
      dispatch({
        type: FETCH_USER_SINGLE_LISTINGS_CONTENT_FAILED,
        payload: error,
      });
    });
};

export const postListing = (formData, listing_id) => (dispatch) => {
  let postUrl = "";
  if (listing_id != undefined && listing_id !== null) {
    postUrl = "edit-user-listing/" + listing_id;
  } else {
    postUrl = "add-user-listing";
  }
  dispatch({
    type: USER_SINGLE_LISTINGS_DELETE__MESSAGE,
    payload: null,
  });

  http
    .post(postUrl, helpers.doObjToFormData(formData))
    .then(({ data }) => {
      if (data.status) {
        toast.success(`${data.msg}`, TOAST_SETTINGS);
        setTimeout(() => {
          window.location.replace("/listing");
        }, 2000);
        dispatch({
          type: USER_SINGLE_LISTINGS_DELETE_MESSAGE_SUCCESS,
          payload: data,
        });
      } else {
        toast.error(<Text string={data.msg} parse={true} />, TOAST_SETTINGS);
        dispatch({
          type: USER_SINGLE_LISTINGS_DELETE__MESSAGE_FAILED,
          payload: null,
        });
      }
    })
    .catch((error) => {
      dispatch({
        type: USER_SINGLE_LISTINGS_DELETE__MESSAGE_FAILED,
        payload: error,
      });
    });
};
